import React from 'react';

import Modal from "../../../src/component/modal/ModalTemplate";
import SingleButton from "../button/SingleButton";

import * as apiUtil from "../../util/apiUtil";
import Loading from "../loading/Loading";

class MessageSavedModal extends React.Component {
    constructor(props){
        super(props);

        this.setLoading = this.setLoading.bind(this);
        this.ajaxInspectGounCampaign = this.ajaxInspectGounCampaign.bind(this);

        this.state = {
            loading: false,
        }
    }//end constructor

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    ajaxInspectGounCampaign() {
        if (! window.confirm(
            "검수 요청 버튼을 누르면 취소가 불가능합니다." +
            "\n검수가 완료된 후 발송 취소 버튼을 누르지 않으면 자동으로 발송 희망 일자에 맞추어 발송이 진행됩니다." +
            "\n검수 요청 진행하시겠습니까?"
        )) {
            return;
        }

        const { campaignUid } = this.props;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/ai/goun/inspect/" + campaignUid,
            method: apiUtil.requestMethod.POST,
            success: async (result) => {
                alert("검수 요청이 완료되었습니다.");

                const { isClose } = this.props;
                isClose();
            }
        });
    }

    render() {
        const { loading } = this.state;
        const { ajaxInspectGounCampaign } = this;
        const { isClose, open, type, isRemind } = this.props;

        return (
            <Modal
                className={"react-modal"}
                open={open}
                handleClose={isClose}
                overlayClassName="modal-overlay"
            >
                <Loading loading={loading}/>
                { !isRemind &&
                    <div className='modal-body'>
                        메시지 등록이 완료되었습니다.<br/>
                        메시지를 발송하시려면 <span className="text-danger">'검수 요청' 버튼을 클릭</span>해주세요.<br/>
                        '검수 요청'을 클릭하셔야 메시지 문구 검수와 발송 절차가 진행됩니다.<br/>
                        검수는 영업일 기준 대략 3~5일 소요될 수 있습니다.<br/>
                        <br/>
                        메시지 문구를 확인하신 후 '검수 요청'을 희망하시는 경우에는 '확인' 버튼을 누르시고 별도 발송 메시지 확인 페이지에서 '검수 요청＇버튼을 클릭해주세요.<br/>
                        {
                            type === 'self' &&
                            <>
                                <br/>
                                문구 수정을 원하시면 발송 취소 후 재등록하셔야합니다.
                            </>
                        }
                    </div>
                }
                { isRemind &&
                    <div className='modal-body'>
                        메시지 등록 승인 요청이 완료되었습니다.<br/>
                        <br/>
                        최종 승인 과정에서 수정이 필요할 경우 회원가입 시 등록하신 이메일로 안내드립니다.<br/>
                    </div>
                }
                <div className='modal-footer'>
                    { !isRemind &&
                        <SingleButton
                            className='btn btn-success btn-md me-2'
                            handleClick={ajaxInspectGounCampaign}
                            label='검수 요청'
                        />
                    }
                    <SingleButton
                        className='btn btn-primary btn-md'
                        handleClick={isClose}
                        label='확인'
                    />
                </div>
            </Modal>
        )
    }// end render
}// end class

export default MessageSavedModal;
